import { render, staticRenderFns } from "./IconLayers.vue?vue&type=template&id=81da702c"
import script from "./IconLayers.vue?vue&type=script&lang=js"
export * from "./IconLayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports